import React, { useState } from "react";
import { BuyButton, DropdownButton, InfoHeader, InfoLinks, InfoPrice, InfoText, InfoWrapper, Like, SingleNftDropdown } from "./SinfleNftInfo.styled";
import ReadMoreReact from "read-more-react";
import ton_logo from "../../../assets/img/ton-logo.svg";
import { iIcon } from "../../../assets/img/iIcon";
import { NavLink } from "react-router-dom";
import { LikeHeart } from "../../../assets/img/LikeHeart";
import { Dot } from "../../../assets/img/Dot";
import { flag } from "../../../assets/img/flag";
import { roundArrow } from "../../../assets/img/roundArrow";
import { share } from "../../../assets/img/share";

export const SingleNftInfo = () => {
  const [like, setLike] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  return (
    <InfoWrapper onMouseLeave={() => setShowDropdown(false)}>
      <InfoHeader>
        <div>
          <h2>RoboTokyo #2</h2>
          <h6>
            On sale for <span>~0.001 ETH</span>
          </h6>
        </div>
        <div>
          <Like
            like={like}
            onClick={(e) => {
              e.preventDefault();
              setLike(!like);
            }}>
            {LikeHeart(like)}
          </Like>
          <DropdownButton onClick={() => setShowDropdown(!showDropdown)}>{Dot()}</DropdownButton>
          {showDropdown && (
            <SingleNftDropdown>
              <button>{flag()}Report</button>
              <button>{roundArrow()}Refresh Metаdаtа</button>
              <button>{share()}Shаre</button>
            </SingleNftDropdown>
          )}
        </div>
      </InfoHeader>
      <InfoText>
        <ReadMoreReact
          ideal={"200"}
          max={"350"}
          readMoreText={"Read More"}
          text={
            "Intergalactic War is a project that begins with an exploration and that later begins by introducing new characters from extraterrestrial races that live in a confederation of galaxies and that once visited our galaxy and left by mistake..."
          }
        />
      </InfoText>
      <InfoPrice>
        <h5>Price</h5>
        <h3>
          37 TON <img src={ton_logo} alt='logo' />
        </h3>
        <span>$48,65</span>
        <span>Plus a network fee of 1 TON {iIcon()}</span>
        <BuyButton>Buy Now</BuyButton>
      </InfoPrice>
      <InfoLinks>
        <NavLink to='/'>
          <img src='../../../assets/img/default/ava/2.png' alt='creator' />
          <div>
            <h6>Creаtor:</h6>
            <span>@Joe</span>
          </div>
        </NavLink>
        <NavLink to='/'>
          <img src='../../../assets/img/default/collection/2.png' alt='creator' />
          <div>
            <h6>Collection:</h6>
            <span>KidzTokyoOfficiаl</span>
          </div>
        </NavLink>
      </InfoLinks>
    </InfoWrapper>
  );
};
